module.exports = __webpack_public_path__ + "img/profile_blank.9acfe78b.png";